module.exports = __webpack_public_path__ + "img/leumicard.573a4f2f.png";